import * as React from 'react';

const Hero = ({ children, className = '' }) => (
  <div className={`hero ${className}`}>
    <div className="hero-body">
      <div className="container">{children}</div>
    </div>
  </div>
);

export default Hero;
